import { SecretValue } from "client/Api/Apps/common";
import { environmentHttpClient } from "client/Api/httpClient";

export interface AfasConnectionListItemModel {
	id: number;
	name: string;
	serverUrl: string;
}

export interface AfasConnectionModel {
	id: number;
	name: string;
	serverUrl: string;
	environmentKey: string;
	useStaticUriForTasks: boolean;
}

export interface AfasConnectionSaveModel {
	name: string;
	serverUrl: string;
	environmentKey: string;
	apiKey: SecretValue;
	useStaticUriForTasks: boolean;
	oneTimePassword: OptionalModel<string>;
}

export enum AfasConnectionSaveResultKind {
	NewConnectionCreated = 0,
	ConnectionUpdated = 1,
	RequireOneTimePassword = 2,
	UnableToValidateConnection = 3,
	RequireEmailAddress = 4
}

interface NewAfasConnectionCreatedResultModel {
	kind: AfasConnectionSaveResultKind.NewConnectionCreated;
	newConnectionId: number;
}

interface AfasConnectionUpdatedResultModel {
	kind: AfasConnectionSaveResultKind.ConnectionUpdated;
}

interface RequireOneTimePasswordResultModel {
	kind: AfasConnectionSaveResultKind.RequireOneTimePassword;
}

interface UnableToValidateAfasConnectionResultModel {
	kind: AfasConnectionSaveResultKind.UnableToValidateConnection;
}

interface RequireEmailAddressResultModel {
	kind: AfasConnectionSaveResultKind.RequireEmailAddress;
}

export type IAfasConnectionSaveResultModel = NewAfasConnectionCreatedResultModel
	| AfasConnectionUpdatedResultModel
	| RequireOneTimePasswordResultModel
	| UnableToValidateAfasConnectionResultModel
	| RequireEmailAddressResultModel;

export interface OtpRequestStepParams {
	connectionId: number | undefined;
	name: string;
	serverUrl: string;
	environmentKey: string;
	apiKey: SecretValue;
	useStaticUriForTasks: boolean;
}

export function list(
	signal?: AbortSignal
): Promise<ReadonlyArray<AfasConnectionListItemModel>> {
	return environmentHttpClient.get<ReadonlyArray<AfasConnectionListItemModel>>(
		"UiApi/AfasConfiguration/List",
		undefined,
		{ signal }
	);
}

export function get(
	id: number,
	signal?: AbortSignal
): Promise<AfasConnectionModel> {
	return environmentHttpClient.get<AfasConnectionModel>(
		`UiApi/AfasConfiguration/${id}`,
		undefined,
		{ signal }
	);
}

export function create(
	model: AfasConnectionSaveModel,
	signal?: AbortSignal
): Promise<IAfasConnectionSaveResultModel> {
	return environmentHttpClient.post<IAfasConnectionSaveResultModel>(
		"UiApi/AfasConfiguration",
		model,
		{ signal }
	);
}

export async function update(
	id: number,
	model: AfasConnectionSaveModel,
	signal?: AbortSignal
): Promise<IAfasConnectionSaveResultModel> {
	return environmentHttpClient.put<IAfasConnectionSaveResultModel>(
		`UiApi/AfasConfiguration/${id}`,
		model,
		{ signal }
	);
}

export function deleteMultiple(
	ids: ReadonlyArray<number>,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.delete<void>(
		"UiApi/AfasConfiguration",
		ids,
		{ signal }
	);
}